import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import * as THREE from 'three';
import { RGBELoader } from 'three-stdlib';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import { Bronze, UpholsteryMaterial } from '../../utils/materials';

export function Eleanor_chair(props) {
  const { nodes, materials, scene } = useGLTF('models/Eleanor Chair.glb');

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    UpholsteryMaterial,
    currentMaterialFinish.upholsteryFinish,
    defaultFinish.upholsteryFinish,
    'ao-eleanor_chair-upholstery',
    aoIntensity,
  );
  // AO maps not generated for legs
  useSetMaterialFinish(
    materials.Leg_Finish_Paint_Color,
    currentMaterialFinish.legPaintColorFinish,
    defaultFinish.legPaintColorFinish,
    // 'setfile',
    // aoIntensity,
  );
  const [hdriTexture, setHdriTexture] = useState(null);

  useEffect(() => {
    // Load the HDRI using RGBELoader
    new RGBELoader()
      .setPath('/hdri/') // Set the path to your HDRI folder
      .load('1.hdr', (texture) => {
        texture.mapping = THREE.EquirectangularReflectionMapping;
        setHdriTexture(texture);
      });
  }, []);

  // Create the Chrome material with the loaded envMap
  const BronzeMaterial = Bronze(hdriTexture);

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  if (!hdriTexture) {
    return null; // Return null while HDRI is loading
  }

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Leg_Finish_Paint_Color.geometry}
        material={materials.Leg_Finish_Paint_Color}
      />
      <mesh
        castShadow
        geometry={nodes.Upholstery.geometry}
        material={UpholsteryMaterial}
      />
      <mesh
        castShadow
        geometry={nodes.Casters.geometry}
        material={BronzeMaterial}
      />
      <Shadow model={'Eleanor Chair'} />
    </group>
  );
}
